import layout from "@/layouts/dashboard";

export default [
    {
        path: "/dashboard",
        name: "dashboard",
        component: layout,
        redirect: {
            name: "dashboard-setting-user",
        },
        children: [
            {
                path: "notification",
                redirect: {
                    name: "dashboard-notification-message",
                },
            },
            // 通知中心
            {
                path: "notification/message",
                name: "dashboard-notification-message",
                component: () => import("@/views/notification/message"),
                meta: {
                    titleKey: "common.routes.messageTitle",
                    descKey: "common.routes.messageDesc",
                },
            },
            {
                path: "notification/message-detail/:id(\\d+)?",
                name: "dashboard-notification-message-detail",
                component: () => import("@/views/notification/message-detail"),
                hidden: true,
                meta: {
                    titleKey: "common.routes.messageTitle",
                    descKey: "common.routes.messageDesc",
                    activeMenu: "dashboard-notification-message",
                },
            },
            {
                path: "notification/email",
                name: "dashboard-notification-email",
                component: () => import("@/views/notification/bind-email.vue"),
                meta: {
                    titleKey: "common.routes.emailTitle",
                    descKey: "common.routes.emailDesc",
                },
            },
            {
                path: "notification/phone",
                name: "dashboard-notification-phone",
                component: () => import("@/views/notification/bind-phone.vue"),
                meta: {
                    titleKey: "common.routes.phoneTitle",
                    descKey: "common.routes.phoneDesc",
                },
            },
            {
                path: "notification/wxmsg",
                name: "dashboard-notification-wxmsg",
                component: () => import("@/views/notification/wxmsg.vue"),
                meta: {
                    titleKey: "common.routes.wechatTitle",
                    descKey: "common.routes.wechatDesc",
                },
            },
        ],
    },
];
